import {FC, useState, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {
  SelectWrapper,
  InputTextWrapper,
  SelectAsyncWrapper,
} from '../../../../../../components/UI/Form/Input'
import {Switch} from '../../../../../../components/UI/Switch'
import {getLaundryOperationById} from '../../../../services'
import {getProfileByUser} from '../../../../../central/services'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {LaundryOperationModel, PointModel, SelectModel} from '../../../../model'
import {TITLE_FORM_LAUNDRY_CLOTHE} from '../../../../util/Constants'
import Swal from 'sweetalert2'
import AditionalForm from '../../../../../../components/UI/Form/aditionalCamp/aditionalCampCentral'
import {initValues} from '../../../../util/values/laundryOperation'
import {clearFields} from '../../../../../../util/functions'
import useServiceList from '../../../../hooks/useService'
import {useCompany, useClient, useSite, useCamp} from '../../../../../central/hooks'
import {useCollaborator, usePoint, useTableMaster} from '../../../../hooks'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
const Laundry: FC = () => {
  const {
    register,
    setError,
    formState: {errors},
    setValue,
    watch,
    getValues,
  } = useFormContext()
  const {currentTabItem} = useLavanderia()
  const [typeService, setTypeService] = useState<SelectModel[]>([])
  const [responsibleOrder, setResponsibleOrder] = useState<SelectModel[]>([])
  const [company, setCompany] = useState<SelectModel[]>([])
  const [clients, setClients] = useState<SelectModel[] | any>([])
  const [sites, setSites] = useState<SelectModel[] | any>([])
  const [camps, setCamps] = useState<SelectModel[]>([])
  const {typeReception, getTypeReceptionList, getResponsaleOrderList} = useTableMaster()
  const {getCompanyFD} = useCompany()
  const {getClientFD} = useClient()
  const {getSiteFD} = useSite()
  const {getCampFD} = useCamp()
  const {getServiceMappedData} = useServiceList()
  const {pointList, getPointList} = usePoint()
  const {getUserCollaboratorData} = useCollaborator()
  const getProfileByUserList = async (id: any) => {
    const response = await getProfileByUser({usuarioId: id}, 1)
    const data = response.data.data
    const filterPerfil = data.filter(
      (item) => item.perfil === 'USUARIO DE LAVANDERÍA' && item.aplicacion === 'Lavandería',
    )
    if (filterPerfil.length === 0) {
      Swal.fire({
        title: 'Huésped, no tiene permiso para usar el servicio de lavandería.',
        text: 'Por favor asignar el permiso en "Central/Usuarios/Permisos"',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: 'var(--kt-primary)',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(async (result) => {
        setValue('colaboradorId', '')
        setError('colaboradorId', {})
        setValue('cargo', '')
        setValue('empresa', '')
        setValue('telefono', '')
        setValue('email', '')
        Swal.close()
      })
    }
  }

  const getCompanyList = async () => {
    const response = await getCompanyFD({})
    if (response.length === 1) {
      setValue('companiaId', response[0].value)
      setError('companiaId', {})
      await getClientList(response[0].value as string)
    }

    setCompany(response)
  }
  const getClientList = async (companyId: string) => {
    const response = await getClientFD({companiaId: companyId})
    if (response.length === 1) {
      setValue('clienteId', response[0].value)
      setError('clienteId', {})
      await getSiteList(response[0].value as string)
    }
    setClients(response)
  }
  const getSiteList = async (clientId: string) => {
    const response = await getSiteFD({clienteId: clientId})
    if (response.length === 1) {
      setValue('siteId', response[0].value)
      setError('siteId', {})
      await getCampList(response[0].value as string)
    }
    setSites(response)
  }
  const getCampList = async (siteId: string) => {
    const response = await getCampFD({siteId: siteId})
    if (response.length === 1) {
      setValue('campamentoId', response[0].value)
      setError('campamentoId', {})
      await getPoint()
    }
    setCamps(response)
  }
  const getPoint = async () => {
    let obj: PointModel = {
      companiaId: getValues('companiaId'),
      clienteId: getValues('clienteId'),
      siteId: getValues('siteId'),
      campamentoId: getValues('campamentoId'),
    }
    await getPointList(obj)
  }

  const getServiceList = async () => {
    const data = await getServiceMappedData({})
    const filterData = data?.filter((item) => item.tipoOrdenLavadoId === 'ROPA OPERACIÓN') || []
    setTypeService(filterData)
  }

  const getResponsaleOrder = async () => {
    try {
      const data = await getResponsaleOrderList()
      const filterData = data?.filter((item) => item.codigo === 'COLABORADOR') || []
      setValue('responsable', filterData[0]?.label || '')
      setValue('responsableId', filterData[0]?.value || '')
      setResponsibleOrder(filterData ?? [])
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getLaundryOperationByIdValues = async () => {
    const response = await getLaundryOperationById(currentTabItem.idToEdit)
    const data = response.data.data
    type LaundryOperationModelKeys = keyof LaundryOperationModel

    for (const fieldName in initValues) {
      if (initValues.hasOwnProperty(fieldName)) {
        if (data.hasOwnProperty(fieldName)) {
          if (data[fieldName as LaundryOperationModelKeys]) {
            if (fieldName === 'clienteId') {
              let valueCompania = data['companiaId']
              let valueClient = data['clienteId']
              getClientList(valueCompania as any)
              setValue('clienteId', valueClient)
            } else if (fieldName === 'siteId') {
              let valueSite = data['siteId']
              let valueClient = data['clienteId']
              getSiteList(valueClient as any)
              setValue('siteId', valueSite)
            } else if (fieldName === 'campamentoId') {
              let valueSite = data['campamentoId']
              let valueClient = data['siteId']
              getCampList(valueClient as any)
              setValue('campamentoId', valueSite)
              getPoint()
            } else if (fieldName === 'campoadicionalFec1') {
              let valueDep = data[fieldName as LaundryOperationModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else if (fieldName === 'campoadicionalFec2') {
              let valueDep = data[fieldName as LaundryOperationModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else {
              setValue(fieldName, data[fieldName as LaundryOperationModelKeys])
            }
          } else {
            setValue(fieldName, '')
          }
        }
      }
    }
  }

  useEffect(() => {
    getResponsaleOrder()
    getCompanyList()
    getServiceList()
    getTypeReceptionList()
  }, [])
  useEffect(() => {
    if (typeReception.length > 0) {
      let getValue = typeReception.filter((item) => item.codigo === 'SISTEMA')
      setValue('tipoRecepcion', getValue[0].value)
    }
  }, [typeReception])

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getLaundryOperationByIdValues()
    }
  }, [currentTabItem.idToEdit])

  const handleGetClient = (e: any) => {
    let value = e.value
    getClientList(value)
    clearFields(setValue, setError, {
      clienteId: '',
      siteId: '',
      campamentoId: '',
    })
  }
  const handleGetSite = (e: any) => {
    let value = e.value
    getSiteList(value)
    clearFields(setValue, setError, {
      siteId: '',
      campamentoId: '',
    })
  }
  const handleGetCamp = (e: any) => {
    let value = e.value
    getCampList(value)
    clearFields(setValue, setError, {
      campamentoId: '',
    })
  }

  const handleGetPoint = (e: any) => {
    getPoint()
  }
  const handleGetTypeAdmin = (e: any) => {
    setValue('tipoAdministracion', e.tipoAdministracion)
    setValue('proveedor', e.proveedor)
  }

  const getInformationColaborador = async (e: any) => {
    let value = e ? e : ''
    setValue('colaborador', value.label)
    setValue('colaboradorId', value.value)
    setValue('cargo', value.cargo)
    setValue('empresa', value.empresaContratanteNombre)
    setValue('telefono', value.telefono)
    setValue('email', value.email)
    await getProfileByUserList(value.value)
  }
  const loadOptions = async (inputValue: string, callback: (options: any[]) => void) => {
    if (inputValue.length < 3) {
      return []
    }
    try {
      const response = await getUserCollaboratorData({
        siteId: watch('siteId') || '',
        buscaTexto: inputValue,
      })
      const mappedGuests = response.map((guest) => ({
        value: guest.usuarioId,
        label: `${guest.nombres} ${guest.materno} ${guest.paterno}`,
        ...guest,
      }))
      return mappedGuests
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <ContentForm title={TITLE_FORM_LAUNDRY_CLOTHE}>
      <div className='row'>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Compañía'
            name='companiaId'
            data={company}
            disabled={isDisabled}
            onChangeValue={handleGetClient}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Cliente'
            name='clienteId'
            data={clients}
            disabled={isDisabled}
            onChangeValue={handleGetSite}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Site'
            name='siteId'
            data={sites}
            disabled={isDisabled}
            onChangeValue={handleGetCamp}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Campamento'
            name='campamentoId'
            data={camps}
            disabled={isDisabled}
            onChangeValue={handleGetPoint}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Tipo de recepción'
            name='tipoRecepcion'
            data={typeReception}
            required
          />
        </div>
        {watch('tipoRecepcion') === 'MANUAL' && (
          <div className='col-sm-12 col-lg-3'>
            <InputTextWrapper
              labelText='Nro de boleta'
              name='nroBoleta'
              type='ticketNumber'
              required
            />
          </div>
        )}
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Punto de Lavandería'
            name='puntoId'
            data={pointList}
            onChangeValue={handleGetTypeAdmin}
            required
          />
        </div>

        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper
            labelText='Tipo de administración'
            name='tipoAdministracion'
            disabled={true}
          />
        </div>
        {watch('tipoAdministracion') === 'EXTERNO' && (
          <div className='col-sm-12 col-lg-3'>
            <InputTextWrapper labelText='Proveedor' name='proveedor' disabled={true} />
          </div>
        )}
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Tipo de servicio de lavado'
            name='servicioId'
            data={typeService}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Responsable de la orden'
            name='responsable'
            data={responsibleOrder}
            disabled={true}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectAsyncWrapper
            labelText='Datos del responsables'
            name='colaboradorId'
            loadOptions={loadOptions}
            onChangeValue={getInformationColaborador}
            value={
              watch('colaboradorId')
                ? {
                    value: watch('colaboradorId') || '',
                    label: watch('colaborador') || '',
                  }
                : null
            }
            required
          />
          {/* <SelectWrapper
            labelText='Datos del responsable'
            name='colaboradorId'
            data={collaborator}
            onChangeValue={getInformationColaborador}
            required
          /> */}
        </div>

        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper labelText='Cargo del colaborador' name='cargo' disabled={true} />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper labelText='Empresa' name='empresa' disabled={true} />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper labelText='Teléfono' name='telefono' disabled={true} />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper labelText='Email' name='email' disabled={true} />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label>Envío de comprobante:</label>
          <Switch register={register} name='flagEnvioComprobante' errors={errors} />
        </div>
      </div>
      <hr className='divider' />
      <AditionalForm />
    </ContentForm>
  )
}

export default Laundry
